import { combineEpics } from 'redux-observable';
import { reloadSpreadProfileListEpic } from './_epic/reloadSpreadProfileList.epic';
import { toggleViewSpreadProfileSidebarEpic } from './_epic/toggleViewSpreadProfileSidebar.epic';
import { closeSpreadProfileBeforeRemoveEpic } from './_epic/closeSpreadProfileBeforeRemove.epic';

export const controllerSpreadProfileEpic = combineEpics(
  reloadSpreadProfileListEpic,
  toggleViewSpreadProfileSidebarEpic,
  closeSpreadProfileBeforeRemoveEpic,
);
